// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--gs5R_","loading":"_93444fe79c--loading--fC43r","spinner":"_93444fe79c--spinner--rWSqM"};